"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBuilder = void 0;
const InternalError_1 = require("./InternalError");
const NotFoundError_1 = require("./NotFoundError");
class ErrorBuilder {
    constructor(response) {
        this.response = response;
    }
    static forResponse(response) {
        return new ErrorBuilder(response);
    }
    build(message) {
        const exceptionMessage = (defaultMessage) => {
            var _a;
            return message || ((_a = this.response.data) === null || _a === void 0 ? void 0 : _a.message) || defaultMessage;
        };
        const getErrorDetails = () => {
            var _a;
            return ((_a = this.response.data) === null || _a === void 0 ? void 0 : _a.details) || {};
        };
        let error;
        switch (this.response.status) {
            case 404:
                error = new NotFoundError_1.NotFoundError(exceptionMessage('Requested entity could not be found'), getErrorDetails());
                break;
            case 500:
            default:
                error = new InternalError_1.InternalError(exceptionMessage('An internal error has occurred'), getErrorDetails());
        }
        return error;
    }
}
exports.ErrorBuilder = ErrorBuilder;
//# sourceMappingURL=ErrorBuilder.js.map